import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface LogPacket extends Doc {
  _id: string;
  runId: number;
  botId?: number;
  bot: string;
  opcode: string;
  packet: string;
  direction: 's' | 'r';
  timestamp?: number;
}

type Model = LogPacket;
type Refs = References<Model>;

export const LogPackets = new Mongo.Collection<LogPacket>('logPackets');

export const listLogPackets = DeclareMethod<ListMethodArg<LogPacket>, ListMethodResponse<LogPacket, Refs>>('listLogPackets');
export const getLogPacket = DeclareMethod<string, GetMethodResponse<LogPacket, Refs>>('getLogPacket');
export const createLogPacket = DeclareMethod<Partial<LogPacket>, string>('createLogPacket');
export const updateLogPacket = DeclareMethod<Partial<LogPacket>, string>('updateLogPacket');
export const deleteLogPacket = DeclareMethod<string, undefined>('deleteLogPacket');

export const modelClass: ModelClass<Model, Refs> = {
  collection: LogPackets,
  editableFields: ['runId', 'botId', 'bot', 'opcode', 'packet', 'direction', 'timestamp'],
  listMethod: listLogPackets,
  getMethod: getLogPacket,
  createMethod: createLogPacket,
  updateMethod: updateLogPacket,
  deleteMethod: deleteLogPacket,
  pathPrefix: '/log-packets',
  modelName: 'Log Packet',
  pluralName: 'Log Packets',
};
